import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import TrainingList from "./pages/TrainingList";
import ChatSession from "./pages/ChatSession";
import Feedback from "./pages/Feedback";
import Progress from "./pages/Progress";
import Academy from "./pages/Academy";
import Admin from "./pages/Admin";
import TeamDashboard from "./pages/TeamDashboard";
import TeamBilling from "./pages/TeamBilling";
import Highlights from "./pages/Highlights";
import RecordingDetail from "./pages/RecordingDetail";
import AdminSessions from "./pages/AdminSessions";
import AdminSessionDetail from "./pages/AdminSessionDetail";
import ProfilePage from "./pages/ProfilePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import Widerruf from "./pages/Widerruf";
import Billing from "./pages/Billing";
import Downloads from "./pages/Downloads";

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-novatus-text-3">Lade...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !["admin", "trainer", "manager", "direktor"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
};

const Root = () => {
  const { user } = useAuth();
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors closeButton />
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/training" element={<Protected><TrainingList /></Protected>} />
            <Route path="/training/session/:sessionId" element={<Protected><ChatSession /></Protected>} />
            <Route path="/training/session/:sessionId/feedback" element={<Protected><Feedback /></Protected>} />
            <Route path="/fortschritt" element={<Protected><Progress /></Protected>} />
            <Route path="/academy" element={<Protected><Academy /></Protected>} />
            <Route path="/highlights" element={<Protected><Highlights /></Protected>} />
            <Route path="/highlights/:recordingId" element={<Protected><RecordingDetail /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/team" element={<Protected adminOnly><TeamDashboard /></Protected>} />
            <Route path="/team/billing" element={<Protected adminOnly><TeamBilling /></Protected>} />
            <Route path="/team/sessions" element={<Protected adminOnly><AdminSessions /></Protected>} />
            <Route path="/team/sessions/:sessionId" element={<Protected adminOnly><AdminSessionDetail /></Protected>} />
            <Route path="/team/users/:userId/profile" element={<Protected adminOnly><ProfilePage /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/payments/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payments/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="/billing" element={<Protected><Billing /></Protected>} />
            <Route path="/downloads" element={<Protected><Downloads /></Protected>} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/widerruf" element={<Widerruf />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
